import React from 'react'

import TextInput from './Text'
import Multiline from './Multiline'
import DateInput from './Date'
import CustomFieldDropDown from './Dropdown'
import MultiselectDropdown from './MultiSelect'
import Checkbox from './Checkbox'
import UserInput from './UserInput'
import TableInput from './TableInput'
import PhoneInput from './PhoneInput'

type CustomFieldInputProps = {
  field: LocalCustomField
  meta: any[]
  shouldFilter?: boolean
} & Record<string, any>

const ELEMENT_MAP: Record<APICustomField['field_type'], React.FC<any>> = {
  text: TextInput,
  multiline: Multiline,
  'date-only': DateInput,
  'date-time': DateInput,
  'month-year': DateInput,
  dropdown: CustomFieldDropDown,
  multiselect: MultiselectDropdown,
  boolean: Checkbox,
  user: UserInput,
  table: TableInput,
  phone: PhoneInput,
  flow: () => null
}

const CustomFieldInput: React.FC<CustomFieldInputProps> = props => {
  const Element = React.useMemo(() => {
    const fieldType = props.field.field_type

    if (fieldType in ELEMENT_MAP) {
      return ELEMENT_MAP[fieldType]
    }

    console.warn(`Unknown object type: ${fieldType}`)
    return null
  }, [props.field.field_type])

  if (!Element) {
    return null
  }

  return <Element {...props} />
}

export default CustomFieldInput
